// API Configuration
export const API_CONFIG = {
  // Use environment variable if available, otherwise use the deployed worker URL
  WORKER_URL:
    (import.meta as any).env?.VITE_WORKER_URL ||
    "https://speech-translation-worker.1ordcommander.workers.dev",

  // WebSocket URL (replace http/https with ws/wss)
  get WEBSOCKET_URL() {
    return this.WORKER_URL.replace(
      /^https?:/,
      this.WORKER_URL.startsWith("https:") ? "wss:" : "ws:"
    );
  },
};
